import React from 'react';
import { Container, Segment, Header, Loader } from 'semantic-ui-react';

import { connect } from 'react-redux';
import { fetchTeams } from '../actions/teams';
import { fetchInvitations, acceptInvitation } from '../actions/invitations';

import TeamCard from '../components/TeamCard';
import InvitationList from '../components/InvitationList';

class Home extends React.Component {
  componentWillMount() {
    this.props.fetchTeams();
    this.props.fetchInvitations();
  }

  renderNewTeamCard() {
    return (
      <Container
        key="new-team"
        fluid
        className="TeamCard TeamCard--new"
        textAlign="center"
      >
        <Header onClick={() => this.props.history.push('/teams/new')}>
          Add a new team
        </Header>
      </Container>
    );
  }

  render() {
    const { teams, invitations } = this.props;

    return (
      <Container className="Home">
        <Loader active={!teams} />
        {invitations && invitations.length > 0 && (
          <Segment>
            <InvitationList
              invitations={invitations}
              onAcceptInvitation={this.props.acceptInvitation}
            />
          </Segment>
        )}
        {teams &&
          teams.map(team => (
            <TeamCard
              key={team.id}
              team={team}
              onClick={() => this.props.history.push(`/team/${team.slug}`)}
            />
          ))}
        {teams && this.renderNewTeamCard()}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  teams: state.teams.teams,
  invitations: state.invitations.invitations
});

const mapDispatchToProps = dispatch => ({
  fetchTeams: () => {
    dispatch(fetchTeams());
  },
  fetchInvitations: () => {
    dispatch(fetchInvitations());
  },
  acceptInvitation: invitationId => {
    dispatch(acceptInvitation(invitationId)).then(() =>
      dispatch(fetchInvitations()).then(() => dispatch(fetchTeams()))
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js